export const ADD_POST = 'ADD_POST'
export const POST_LOADING = 'POST_LOADING'
export const POST_FAILED = 'POST_FAILED'
export const GET_POST = 'GET_POST'
export const SINGLE_POST = 'SINGLE_POST'
export const ADD_USER = 'ADD_USER'
export const LOGIN_USER = 'LOGIN_USER'
export const GET_USER = 'GET_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_POST = 'UPDATE_POST'
export const UPDATE_POST_PIC = 'UPDATE_POST_PIC'
export const GET_GUEST = 'GET_GUEST'
export const ADD_NOTIF = 'ADD_NOTIF'
export const GET_NOTIF = 'GET_NOTIF'